import { useCallback, useMemo, useState } from 'react';

import { getSessionStorageItem, setSessionStorageItem } from '@revenuemarket/browser';

interface PersistStateOptionsBase {
  name: string;
}

interface PersistStateOptions<T> extends PersistStateOptionsBase {
  defaultValue: T;
}

interface PersistState<T> {
  name: string;
  value: T;
}

export function usePersistState<T>(options: PersistStateOptions<T>) {
  const [value, setValue] = useState<T>(
    () => getSessionStorageItem<PersistState<T>>(options.name)?.value ?? options.defaultValue,
  );

  const setValueInternal = useCallback(
    (incoming: T) => {
      setValue(incoming);
      setSessionStorageItem<PersistState<T>>(options.name, {
        name: options.name,
        value: incoming,
      });
    },
    [options.name],
  );

  return useMemo(() => [value, setValueInternal] as const, [setValueInternal, value]);
}
